import {
  BASE_URL,
  RULE_ENGINE_BASE_URL,
  TRANSACTION,
  TRANSACTION_DATA,
  TRANSACTION_MESSAGE,
  UPDATE_TRANSACTION_MESSAGE,
  REPROCESS_TRANSACTION_MESSAGE,
  ERROR_MSG,
  SUCCESS,
  DISCARDED_TRANSACTION,
  RESTORE_TRANSACTION,
  QAFLAG,
  TRANSACTION_AUDIT_LOGGING,
  MULTIPLE,
  API_GATEWAY_KEY,
  WITHDELETED,
  DUPLICATE,
  REPROCESS_EICR_TRANSACTION_MESSAGE,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchMasterTransactionDataWithFilter = async (
  pageNo,
  recordsPerPage,
  urlWithFilterParams
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?${urlWithFilterParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchErrorTransactionData = async (pageNo, recordsPerPage) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?errorCodeNot=VE08,VE07`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );

  return response;
};

export const fetchErrorTransactionDataWithFilter = async (
  pageNo,
  recordsPerPage,
  urlWithFilterParams
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?errorCodeNot=VE08,VE07&${urlWithFilterParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchUnknownFacilityTransactionData = async (
  pageNo,
  recordsPerPage
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?errorCode=VE08`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchUnknownFacilityTransactionDataWithFilter = async (
  pageNo,
  recordsPerPage,
  urlWithFilterParams
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?errorCode=VE08&${urlWithFilterParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );

  return response;
};

export const fetchDuplicateTransactionDataWithFilter = async (
  pageNo,
  recordsPerPage,
  urlWithFilterParams
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_DATA}/${pageNo}/${recordsPerPage}?status=DUPLICATE&${urlWithFilterParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );

  return response;
};

export const fetchDiscardedTransactionData = async (
  pageNo,
  recordsPerPage,
  urlWithFilterParams
) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION}${DISCARDED_TRANSACTION}/${pageNo}/${recordsPerPage}?${urlWithFilterParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );

  return response;
};

export const restoreTransactionRecord = async (transactionId) => {
  let response = await fetch(
    `${BASE_URL}${RESTORE_TRANSACTION}/${transactionId}`,
    {
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify({}),
    }
  );
  if (response.ok) {
    return SUCCESS;
  } else {
    return ERROR_MSG;
  }
};

export const updateTransactionFields = async (transaction) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION}`,
    {
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(transaction),
    }
  );
  return response;
};

export const fetchTransactionById = async (transactionId) => {
  let response = await fetch(`${BASE_URL}${TRANSACTION}${WITHDELETED}/${transactionId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });

  return response;
};

export const fetchTransactionHL7 = async (transactionId) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_MESSAGE}/${transactionId}/file=hl7`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchDuplicateTransaction = async (transactionId) => {
  let response = await fetch(`${BASE_URL}${TRANSACTION}${DUPLICATE}/${transactionId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchTransactionQAFlags = async (transactionId) => {
  let response = await fetch(
    `${BASE_URL}${QAFLAG}${TRANSACTION}/${transactionId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const addTransactionQAFlags = async (badge) => {
  let response = await fetch(`${BASE_URL}${QAFLAG}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(badge),
  });
  return response;
};

export const removeTransactionQAFlags = async (qaFlagId) => {
  let response = await fetch(`${BASE_URL}${QAFLAG}/${qaFlagId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const updateTransactionQAFlags = async (badge) => {
  let response = await fetch(`${BASE_URL}${QAFLAG}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(badge),
  });
  return response;
};

export const fetchTransactionJSON = async (transactionId) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_MESSAGE}/${transactionId}/file=json`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchTransactionDetails = async (transactionId) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION_AUDIT_LOGGING}${TRANSACTION}/${transactionId}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const updateTransactionRecord = async (form) => {
  let response = await fetch(
    `${RULE_ENGINE_BASE_URL}${UPDATE_TRANSACTION_MESSAGE}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(form),
    }
  );
  return response;
};

export const reprocessBulkTransactionRecord = async (payload) => {
  if (payload.startDate) {
    payload.startDate = payload.startDate + "T00:00:00";
  }
  if (payload.endDate) {
    payload.endDate = payload.endDate + "T00:00:00";
  }
  let response = await fetch(
    `${RULE_ENGINE_BASE_URL}${REPROCESS_TRANSACTION_MESSAGE}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(payload),
    }
  );
  let data = await response.json();
  return data;
};

export const reprocessBulkEicrTransactionRecord = async (payload) => {
  if (payload.startDate) {
    payload.startDate = payload.startDate + "T00:00:00";
  }
  if (payload.endDate) {
    payload.endDate = payload.endDate + "T00:00:00";
  }
  let response = await fetch(
    `${RULE_ENGINE_BASE_URL}${REPROCESS_EICR_TRANSACTION_MESSAGE}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(payload),
    }
  );
  let data = await response.json();
  return data;
};


export const removeTransactionRecord = async (transactionId) => {
  let response = await fetch(`${BASE_URL}${TRANSACTION}/${transactionId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (!response.ok) {
    return ERROR_MSG;
  }
};

export const removeTransactionRecords = async (transactionIds) => {
  let response = await fetch(
    `${BASE_URL}${TRANSACTION}${MULTIPLE}/${transactionIds}`,
    {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  if (!response.ok) {
    return ERROR_MSG;
  }
};
